import React, { useEffect, useState } from "react";
import { getFaqs } from "../api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FaqBlock({ limit }) {
  const [items, setItems] = useState([]);
  useEffect(() => { getFaqs().then((f) => setItems(limit ? f.slice(0, limit) : f)).catch(() => {}); }, [limit]);

  return (
    <section className="py-20 section-cream">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-[380px_1fr] gap-14 items-start">
        <div>
          <div className="chip mb-4">FAQ</div>
          <h2 className="font-display text-3xl md:text-5xl font-medium leading-tight mb-4">Everything you might be wondering</h2>
          <p className="text-slate-500 leading-relaxed mb-6">Answers to the questions we hear most. Still stuck? WhatsApp us anytime.</p>
          <Link to="/faq" className="btn-ghost">See all FAQs <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {items.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-neutral-300">
              <AccordionTrigger className="text-left text-base font-semibold py-5 hover:no-underline hover:text-[#e30613]">{f.question}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-5">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
